import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  list: {
    margin: 0,
    paddingLeft: 30
  }
}))
